import React, { useEffect, useRef, useState } from 'react';
import { useColorScheme } from '@mui/material/styles';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import SettingsBrightnessOutlinedIcon from '@mui/icons-material/SettingsBrightnessOutlined';
import CheckIcon from '@mui/icons-material/Check';
import axiosInstance from './axiosInstance';

// D3: Umschalter Hell / Dunkel / System in der Topbar.
// Quelle der Wahrheit ist UserPreference.theme (Backend); useColorScheme
// hält den Modus zusätzlich in localStorage, damit die App schon vor der
// Antwort des Servers im zuletzt gewählten Modus startet.
const OPTIONS = [
  { value: 'light',  label: 'Hell',   icon: <LightModeOutlinedIcon fontSize="small" /> },
  { value: 'dark',   label: 'Dunkel', icon: <DarkModeOutlinedIcon fontSize="small" /> },
  { value: 'system', label: 'System', icon: <SettingsBrightnessOutlinedIcon fontSize="small" /> },
];

const ICON_BY_MODE = {
  light:  <LightModeOutlinedIcon />,
  dark:   <DarkModeOutlinedIcon />,
  system: <SettingsBrightnessOutlinedIcon />,
};

const ThemeModeToggle = () => {
  const { mode, setMode } = useColorScheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const synced = useRef(false);

  // Gespeicherte Präferenz einmalig vom Server holen
  useEffect(() => {
    if (synced.current) return;
    synced.current = true;
    axiosInstance.get('/me/preferences/')
      .then((r) => { if (r.data?.theme) setMode(r.data.theme); })
      .catch(() => {});
  }, [setMode]);

  const choose = (value) => {
    setAnchorEl(null);
    if (value === mode) return;
    setMode(value);
    axiosInstance.patch('/me/preferences/', { theme: value }).catch(() => {});
  };

  return (
    <>
      <Tooltip title="Darstellung">
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          sx={{ color: 'text.secondary', '&:hover': { color: 'primary.main' } }}
          aria-label="Darstellung wählen"
        >
          {ICON_BY_MODE[mode] || ICON_BY_MODE.light}
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(null)}>
        {OPTIONS.map((o) => (
          <MenuItem key={o.value} selected={o.value === mode} onClick={() => choose(o.value)} sx={{ minWidth: 170 }}>
            <ListItemIcon>{o.icon}</ListItemIcon>
            <ListItemText primary={o.label} />
            {o.value === mode && <CheckIcon fontSize="small" sx={{ color: 'primary.main' }} />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default ThemeModeToggle;
